export class GraticulesDef {
  enabled = false;
  latitudeInterval = 5;
  longitudeInterval = 10;
  strokeWidth = 1;
  strokeColor = 'rgba(178, 190, 181, 255)';
  zindex = 10;
  enableLabels = true;
}
